import { render, staticRenderFns } from "./EditEventDialog.vue?vue&type=template&id=068bf632&scoped=true"
import script from "@/views/Users/Teacher/EditEventDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Teacher/EditEventDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Teacher/edit-event-dialog.scss?vue&type=style&index=0&id=068bf632&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068bf632",
  null
  
)

export default component.exports